<!-- login页面 code === "111" 照片重置，重新上传，审批中-->
<template>
    <div class="uploadTip">
        <div class="tipImgDiv">
            <img src="../IdentitAuthentication/images/btn_shenhe_nor.png" alt="" class="tipImg">
        </div>
        <div class="tipTitle">审核中</div>
        <div class="tips">您的证件照已提交，请等待工作人员审核。</div>
        <div class="gotoUploadBtn" @click="drawer = true">联系工作人员</div>
        <div>
            <van-popup v-model:show="drawer" round position="bottom" :style="{ height: '30%' }">
                <div style="border-bottom: 1px solid #DFDFDF;" class="com-item">工作人员联系电话</div>
                <a :href="'tel:13591668838'">
                    <div style="border-bottom: 1px solid #DFDFDF;" class="com-item">13591668838</div>
                </a>
                <div class="com-item" @click="drawer = false">取消</div>
            </van-popup>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            drawer: false
        }
    },
    created() {

    },
    methods: {
    }
}
</script>
<style scoped lang="less">
.uploadTip {
    position: relative;
    min-height: 100vh;

    .tipImgDiv {
        position: absolute;
        top: 10%;
        left: 50%;
        transform: translateX(-50%);
        width: 50%;
        height: 37.5vw;

        .tipImg {
            width: 100%;
            height: 100%;
        }
    }

    .tipTitle {
        position: absolute;
        top: 32%;
        left: 50%;
        transform: translateX(-50%);
        font-size: 1.5rem;
        font-weight: 400;
        color: #333333;
    }

    .tips {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translateX(-50%);
        font-weight: 400;
        width: 80%;
        text-indent: 2em;
        font-size: 1.2rem;
        line-height: 1.8rem;
        color: #333333;
    }

    .gotoUploadBtn {
        width: 80%;
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translateX(-50%);
        background: #00706E;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        padding: 10px 0;
        font-size: 1.3rem;
        border-radius: 45px;
    }
}

// 底部弹出层
.com-item {
    text-align: center;
    font-size: 1.2rem;
    padding: 20px 0;
}

a {
    color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/uploadUserPhoto/uploadSucc.vue